import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropertiesHero from '../components/properties/propertieshero';
import PropertiesResults from '../components/properties/PropertiesResults';
import Seo from '../components/seo/Seo';

const Properties: React.FC = () => {
  const location = useLocation();

  const getInitialListingType = (): 'all' | 'sale' | 'rent' => {
    const params = new URLSearchParams(location.search);
    const lt = params.get('listingType');
    return lt === 'sale' || lt === 'rent' ? lt : 'all';
  };

  const getHighlightId = (): number | undefined => {
    const params = new URLSearchParams(location.search);
    const raw = params.get('highlightId');
    const value = raw ? Number(raw) : NaN;
    return Number.isFinite(value) && value > 0 ? value : undefined;
  };

  const [listingType, setListingType] = useState<'all' | 'sale' | 'rent'>(
    getInitialListingType,
  );
  const getInitialPropertyType = ():
    | 'all'
    | 'apartments'
    | 'villas'
    | 'plots'
    | 'hotels'
    | 'projects_offplan' => {
    const params = new URLSearchParams(location.search);
    const pt = params.get('propertyType');
    if (
      pt === 'apartments' ||
      pt === 'villas' ||
      pt === 'plots' ||
      pt === 'hotels' ||
      pt === 'projects_offplan'
    ) {
      return pt;
    }
    return 'all';
  };

  const [propertyType, setPropertyType] = useState<
    'all' | 'apartments' | 'villas' | 'plots' | 'hotels' | 'projects_offplan'
  >(getInitialPropertyType);

  const highlightId = getHighlightId();

  const params = new URLSearchParams(location.search);
  const locationQuery = params.get('location') || '';
  const minPriceParam = params.get('minPrice');
  const maxPriceParam = params.get('maxPrice');
  const minPrice = minPriceParam ? Number(minPriceParam) : undefined;
  const maxPrice = maxPriceParam ? Number(maxPriceParam) : undefined;

  // Keep listingType in sync if the URL query changes (e.g. navigated from HomeHero)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lt = params.get('listingType');
    if (lt === 'sale' || lt === 'rent') {
      setListingType(lt);
    } else {
      setListingType('all');
    }
  }, [location.search]);

  return (
    <main className="bg-white">
      <Seo
        title="Dubai & USA Property Listings"
        description="Browse curated Dubai and USA properties for sale and rent with Hogar Dorado House – apartments, villas, plots, hotels, and off-plan projects."
        pathname="/properties"
        keywords={[
          'Dubai properties',
          'USA properties',
          'America properties',
          'apartments for sale',
          'villas for sale',
          'Dubai rentals',
          'off plan projects',
          'buy house in Dubai',
          'buy apartment in Dubai',
          'buy property in America',
          'luxury Dubai villas',
          'most extravagant houses',
          'best properties in Dubai',
          'best properties in USA'
        ]}
      />
      <PropertiesHero
        listingType={listingType}
        onListingTypeChange={setListingType}
        propertyType={propertyType}
        onPropertyTypeChange={setPropertyType}
      />
      <PropertiesResults
        listingType={listingType}
        propertyType={propertyType}
        highlightId={highlightId}
        locationQuery={locationQuery}
        minPrice={minPrice}
        maxPrice={maxPrice}
      />
    </main>
  );
};

export default Properties;
